module.exports = __webpack_public_path__ + "static/media/solutions-mobile.57f7d011.jpg";